import { IApplicationState } from 'setup/store'

export const selectPaymentState = (state: IApplicationState) => state.payment.data
export const selectPaymentCommunication = (state: IApplicationState) => state.payment.communications

export const selectCryptoCurrenciesList = (state: IApplicationState) => state.payment.data.cryptoCurrenciesList

export const selectDepositSystemList = (state: IApplicationState) => state.payment.data.deposit.systemList
export const selectPayoutSystemList = (state: IApplicationState) => state.payment.data.payout.systemList
export const selectDepositData = (state: IApplicationState) => state.payment.data.deposit.createdDeposit
export const selectCryptoMinAmountByCurrency = (state: IApplicationState) =>
  state.payment.data.cryptoMinAmountByCurrency
export const selectConvertedAmountData = (state: IApplicationState) => state.payment.data.convertedAmountData

export const selectScreenshotsData = (state: IApplicationState) => state.payment.data.deposit.screenshotsData

export const selectCreateDepositComm = (state: IApplicationState) => state.payment.communications.createDeposit
export const selectCreatePayoutComm = (state: IApplicationState) => state.payment.communications.createPayout
export const selectCancelPaymentComm = (state: IApplicationState) => state.payment.communications.cancelPayment
export const selectConvertedAmountDataComm = (state: IApplicationState) =>
  state.payment.communications.getCryptoEstimateAmount

export const selectGetDepositSystemListCommunication = (state: IApplicationState) =>
  state.payment.communications.getDepositSystemList
export const selectGetPayoutSystemListCommunication = (state: IApplicationState) =>
  state.payment.communications.getPayoutSystemList
export const selectGetCryptoCurrencyListCommunication = (state: IApplicationState) =>
  state.payment.communications.getCryptoCurrencies

export const selectUploadDocumentComm = (state: IApplicationState) => state.payment.communications.uploadDocument

export const selectGetCashiersList = (state: IApplicationState) => state.payment.data.cashiersList
